

// import React, { useState, useEffect } from "react";
// import "../css/BottleGuide.css";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from '../config';

// const perfumes = [
//   { 
//     id: 1, 
//     name: "2.5ml Decant", 
//     image: "/assets/images/perfumes/2ml_and_5ml.jpg",
//     description: "Rectangle screw neck glass bottle with metal sprayer. It's a 5ml bottle filled in half." 
//   },
//   { 
//     id: 2, 
//     name: "5ml Decant", 
//     image: "/assets/images/perfumes/2ml_and_5ml.jpg",
//     description: "Rectangle screw neck glass bottle with metal sprayer." 
//   },
//   { 
//     id: 3, 
//     name: "10ml Decant", 
//     image: "/assets/images/perfumes/10ml.jpg",
//     description: "Rectangle screw neck glass bottle with metal sprayer. Please note lipstick style travel atomizer is also available with extra 100/- for each bottle." 
//   },
//   { 
//     id: 4, 
//     name: "11ml Decant", 
//     image: "/assets/images/perfumes/11ml.jpg",
//     description: "Cylindrical crimp glass bottle with pressurized atomizer." 
//   },
//   {
//     id: 5, 
//     name: "20ml Decant", 
//     image: "/assets/images/perfumes/20ml.jpeg",
//     description: "Though not mentioned in decant list 20 ml can be done on special request, please add 10mlX2 and mention during checkout." 
//   },
//   { 
//     id: 6, 
//     name: "30ml Decant", 
//     image: "/assets/images/perfumes/30ml.jpg",
//     description: "Cylindrical/Rectangle crimp/screw neck glass bottle with pressurized atomizer as per availability." 
//   },
// ];

// function BottleGuide() {
//   const navigate = useNavigate();
//   const [loadedImages, setLoadedImages] = useState({});
//   const [logoData, setLogoData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   useEffect(() => {
//     fetchLogoData();
//   }, []);

//   const fetchLogoData = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       console.log('Starting to fetch logo data for BottleGuide...');

//       // Fetch logo data
//       const logoResponse = await axiosInstance.get('/user/logos');
//       console.log('Logo API Response:', logoResponse.data);

//       if (logoResponse.data.success && logoResponse.data.data && logoResponse.data.data.length > 0) {
//         // Get the first active logo
//         const activeLogo = logoResponse.data.data.find(logo => logo.is_active === true);
//         console.log('Active Logo Found:', activeLogo);
        
//         if (activeLogo) {
//           setLogoData(activeLogo);
//           console.log('Logo URL to load:', activeLogo.image_url);
//         } else {
//           console.log('No active logo found');
//           setError('No active logo found');
//         }
//       } else {
//         console.log('No logo data received or API not successful');
//         setError('No logo data available');
//       }

//     } catch (err) {
//       console.error('Error fetching logo data:', err);
//       setError('Failed to load logo: ' + err.message);
//     } finally {
//       setLoading(false);
//       console.log('Logo loading complete');
//     }
//   };

//   const handleClick = () => {
//     navigate('/');
//   }

//   const handleImageLoad = (id) => {
//     setLoadedImages(prev => ({ ...prev, [id]: true }));
//   };

//   const handleLogoError = (e) => {
//     console.error('Logo image failed to load:', e.target.src);
//     e.target.style.display = 'none';
//   };

//   return (
//     <div className="bottle-guide-container">
//       <header className="guide-header">
//         <div className="header-container">
//           <div className="header-left">
//             <p className="subtitle" onClick={handleClick}>
//               <span className="back-arrow">←</span> Home
//             </p>
//           </div>
//           <div className="header-right">
//             <div className="header-logo">
//               {loading ? (
//                 <div className="logo-placeholder">
//                   Loading...
//                 </div>
//               ) : logoData ? (
//                 <img 
//                   src={logoData.image_url} 
//                   alt="Luxury Fragrance Decants Logo" 
//                   className="logo-img"
//                   onError={handleLogoError}
//                   onLoad={() => console.log('Logo loaded successfully:', logoData.image_url)}
//                 />
//               ) : (
//                 <div className="logo-placeholder">
//                   No Logo
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </header>

//       <section className="view-guide-wrapper">
//         <div className="view-guide-header">
//           <h1>Sample Decants</h1>
//         </div>

//         <div className="perfume-grid">
//           {perfumes.map((perfume, index) => (
//             <div 
//               key={perfume.id} 
//               className="perfume-card"
//               data-index={index + 1}
//             >
//               <div className="card-top-section">
//                 <div className="perfume-image-wrapper">
//                   <img 
//                     src={perfume.image} 
//                     alt={perfume.name} 
//                     className={`perfume-image ${!loadedImages[perfume.id] ? 'loading' : ''}`}
//                     onLoad={() => handleImageLoad(perfume.id)}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = "/assets/images/perfumes/default.jpg";
//                     }}
//                     loading="lazy"
//                   />
//                 </div>
//                 <h3 className="perfume-name">{perfume.name}</h3>
//               </div>
              
//               <div className="card-bottom-section">
//                 <p className="perfume-description">{perfume.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// }

// export default BottleGuide;



import React, { useState, useEffect } from "react";
import "../css/BottleGuide.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from '../config';

const static20ml = {
  id: 5, 
  size: "20ml", 
  name: "20ml Decant",
  image: "/assets/images/perfumes/20ml.jpeg",
  description: "Though not mentioned in decant list 20 ml can be done on special request, please add 10mlX2 and mention during checkout.",
  is_static: true
};

function BottleGuide() {
  const navigate = useNavigate();
  const [loadedImages, setLoadedImages] = useState({});
  const [logoData, setLogoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sizes, setSizes] = useState([]);
  const [perfumes, setPerfumes] = useState([]);
  
  useEffect(() => {
    fetchLogoData();
    fetchSizes();
  }, []);

  const fetchLogoData = async () => {
    try {
      const logoResponse = await axiosInstance.get('/user/logos');
      console.log('Logo API Response:', logoResponse.data);

      if (logoResponse.data.success && logoResponse.data.data && logoResponse.data.data.length > 0) {
        const activeLogo = logoResponse.data.data.find(logo => logo.is_active === true);
        console.log('Active Logo Found:', activeLogo);
        
        if (activeLogo) {
          setLogoData(activeLogo);
        }
      }
    } catch (err) {
      console.error('Error fetching logo data:', err);
    }
  };

  const fetchSizes = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('Fetching sizes data for BottleGuide...');
      const response = await axiosInstance.get('/user/size-masters');
      console.log('Sizes API Response:', response.data);

      if (response.data.status && response.data.data) {
        const dynamicSizes = response.data.data.map(size => ({
          id: size.id,
          name: `${size.size} Decant`,
          size: size.size,
          image: size.full_image_url || 
                 (size.image && !size.image.startsWith('http') ? 
                  `${axiosInstance.defaults.baseURL.replace('/api', '')}/storage/size_images/${size.image}` : 
                  size.image),
          description: size.description,
          is_static: false
        }));
        const sortedSizes = dynamicSizes.sort((a, b) => {
          const getNumericValue = (sizeStr) => {
            const match = sizeStr.match(/(\d+(\.\d+)?)/);
            return match ? parseFloat(match[1]) : 0;
          };
          return getNumericValue(a.size) - getNumericValue(b.size);
        });

        // Add static 20ml after 11ml (or at appropriate position)
        let allPerfumes = [];
        let inserted20ml = false;
        
        sortedSizes.forEach(size => {
          // Insert 20ml after 11ml or before 30ml
          if (!inserted20ml && (size.size === '11ml' || (parseFloat(size.size) > 11 && parseFloat(size.size) < 30))) {
            allPerfumes.push(size);
            allPerfumes.push(static20ml);
            inserted20ml = true;
          } else {
            allPerfumes.push(size);
          }
        });

        // If 20ml wasn't inserted (edge case), add it at the end
        if (!inserted20ml) {
          allPerfumes.push(static20ml);
        }

        // Re-index IDs for display
        allPerfumes = allPerfumes.map((perfume, index) => ({
          ...perfume,
          displayId: index + 1
        }));

        console.log('Final perfume list:', allPerfumes);
        setSizes(response.data.data);
        setPerfumes(allPerfumes);
      } else {
        throw new Error('API returned unsuccessful response');
      }
    } catch (err) {
      console.error('Error fetching sizes:', err);
      setError('Failed to load bottle guide data');
      // Fallback to static data if API fails
      setPerfumes([
        { 
          id: 1, 
          name: "2.5ml Decant", 
          image: "/assets/images/perfumes/2ml_and_5ml.jpg",
          description: "Rectangle screw neck glass bottle with metal sprayer. It's a 5ml bottle filled in half." 
        },
        { 
          id: 2, 
          name: "5ml Decant", 
          image: "/assets/images/perfumes/2ml_and_5ml.jpg",
          description: "Rectangle screw neck glass bottle with metal sprayer." 
        },
        { 
          id: 3, 
          name: "10ml Decant", 
          image: "/assets/images/perfumes/10ml.jpg",
          description: "Rectangle screw neck glass bottle with metal sprayer. Please note lipstick style travel atomizer is also available with extra 100/- for each bottle." 
        },
        { 
          id: 4, 
          name: "11ml Decant", 
          image: "/assets/images/perfumes/11ml.jpg",
          description: "Cylindrical crimp glass bottle with pressurized atomizer." 
        },
        static20ml,
        { 
          id: 6, 
          name: "30ml Decant", 
          image: "/assets/images/perfumes/30ml.jpg",
          description: "Cylindrical/Rectangle crimp/screw neck glass bottle with pressurized atomizer as per availability." 
        },
      ]);
    } finally {
      setLoading(false);
      console.log('Sizes loading complete');
    }
  };

  const handleClick = () => {
    navigate('/');
  }

  const handleImageLoad = (id) => {
    setLoadedImages(prev => ({ ...prev, [id]: true }));
  };

  const handleLogoError = (e) => {
    console.error('Logo image failed to load:', e.target.src);
    e.target.style.display = 'none';
  };

  const handleImageError = (e, defaultImage = "/assets/images/perfumes/default.jpg") => {
    console.error('Perfume image failed to load:', e.target.src);
    e.target.onerror = null;
    e.target.src = defaultImage;
  };

  if (loading) {
    return (
      <div className="bottle-guide-container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading Bottle Guide...</p>
        </div>
      </div>
    );
  }

  if (error && perfumes.length === 0) {
    return (
      <div className="bottle-guide-container">
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button onClick={fetchSizes} className="retry-button">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bottle-guide-container">
      <header className="guide-header">
        <div className="header-container">
          <div className="header-left">
            <p className="subtitle" onClick={handleClick}>
              <span className="back-arrow">←</span> Home
            </p>
          </div>
          <div className="header-right">
            <div className="header-logo">
              {logoData ? (
                <img 
                  src={logoData.image_url} 
                  alt="Luxury Fragrance Decants Logo" 
                  className="logo-img"
                  onError={handleLogoError}
                  onLoad={() => console.log('Logo loaded successfully:', logoData.image_url)}
                />
              ) : (
                <div className="logo-placeholder">
                  No Logo
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <section className="view-guide-wrapper">
        <div className="view-guide-header">
          <h1>Sample Decants</h1>
        </div>

        <div className="perfume-grid">
          {perfumes.map((perfume, index) => (
            <div 
              key={perfume.id || perfume.displayId} 
              className="perfume-card"
              data-index={perfume.displayId || index + 1}
            >
              <div className="card-top-section">
                <div className="perfume-image-wrapper">
                  <img 
                    src={perfume.image} 
                    alt={perfume.name} 
                    className={`perfume-image ${!loadedImages[perfume.id || perfume.displayId] ? 'loading' : ''}`}
                    onLoad={() => handleImageLoad(perfume.id || perfume.displayId)}
                    onError={(e) => handleImageError(e, perfume.is_static ? "/assets/images/perfumes/default.jpg" : "/assets/images/perfumes/default.jpg")}
                    loading="lazy"
                  />
                </div>
                <h3 className="perfume-name">{perfume.name}</h3>
              </div>
              
              <div className="card-bottom-section">
                <p className="perfume-description">{perfume.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default BottleGuide;